import styled from 'styled-components';

const OverflowWrapper = styled.div`
  overflow: hidden;
`;

export default OverflowWrapper;
